(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swish/components/deposit-credentials-wrapper.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swish/components/deposit-credentials-wrapper.js');

'use strict';

const {
  newCellphoneChangeAction
} = svs.accountservicesReact.deposit.store.swish.actions;
const {
  SwishCellphone
} = svs.accountservicesReact.swishCellphone;
const DepositCredentialsWrapper = () => {
  const dispatch = ReactRedux.useDispatch();
  const cellPhone = ReactRedux.useSelector(state => state.swish.cellPhone);
  const newCellPhone = ReactRedux.useSelector(state => state.swish.newCellPhone);
  const updatePhone = number => {
    dispatch(newCellphoneChangeAction(number));
  };
  return React.createElement(SwishCellphone, {
    cellphone: cellPhone,
    isDeposit: true,
    newCellphone: newCellPhone,
    setNewCellphone: number => updatePhone(number)
  });
};
svs.accountservicesReact.deposit.swish.components.DepositCredentialsWrapper = DepositCredentialsWrapper;

 })(window);